export const MOO_COMPANY_ID = 92;
export const MOO_HEALTH_CATEGORIES_DEFAULT_VALUE = 'Standard';
export const MOO_PRODUCT_TYPE_DEFAULT_VALUE = 'Final Expense';
export const STATE_OPTIONS = [
    'AK',
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
];
export const AGENIUM_OCUPATION_LIST = [
    'Accountant',
    'Actor Actress',
    'Actuary',
    'Administrative Staff',
    'Adult entertainment industry including internet',
    'Advertising',
    'Aircraft Engineer',
    'Aircraft Loader',
    'Aircraft Maintenance and Repair',
    'Anesthetist',
    'Animal Worker',
    'Architect',
    'Armed Forces Member',
    'Artist',
    'Asbestos worker',
    'Assembler',
    'Assembly Line Worker',
    'Atomic Energy Worker',
    'Auditor',
    'Author',
    'Bailiff',
    'Baker',
    'Bank Staff',
    'Barber',
    'Bartender',
    'Beautician Beauty Therapist',
    'Biochemist',
    'Blacksmith',
    'Blaster',
    'Bookkeeper',
    'Builder',
    'Building Contractor',
    'Building Demolition Contractor',
    'Bus Driver',
    'Business Analyst',
    'Business Consultant',
    'Business Owner',
    'Butcher',
    'Buyer',
    'Cabin Crew',
    'Call Center',
    'Car Mechanic',
    'Car Valet',
    'Care Worker',
    'Carpenter',
    'Cashier',
    'Caterer',
    'CEO',
    'Chef',
    'Chemist',
    'Child Carer',
    'Chiropractor',
    'Cinema Worker',
    'CIO',
    'Civil Engineer',
    'Claims Adjuster Assessor',
    'Classroom Assistant',
    'Cleaner',
    'Clergy',
    'Clerical Assistant Officer Worker',
    'Clerk',
    'Coast Guard',
    'Comedian',
    'Commercial Fisherman - Inshore',
    'Commercial Fisherman - Offshore',
    'Community Worker',
    'Compliance',
    'Computer Analyst',
    'Computer Analyst Programmer Consultant',
    'Computer Engineer',
    'Consultant',
    'Court Usher',
    'CPA',
    'CRO',
    'CTO',
    'Customer Service',
    'Dancer',
    'Debt Collector',
    'Dental Assistant',
    'Dental Hygienist',
    'Dentist',
    'Dentist - Specialist',
    'Dietician',
    'Diplomat',
    'Director',
    'Director of Operations',
    'Diver',
    'Diving Instructor',
    'Doctor (Not Armed Forces)',
    'Driver',
    'Economist',
    'Electrical Engineer',
    'Electrician',
    'Engineer',
    'Estate Agent',
    'Executive',
    'Factory Worker',
    'Farmer',
    'Farming - Marijuana or Cannabis related',
    'Farming - Not Marijuana or Cannabis related',
    'Finance',
    'Financial Adviser',
    'Financial Analyst',
    'Financial Trader',
    'Firefighter (Municipal)',
    'Fisherman',
    'Fitness Instructor',
    'Flight Attendant',
    'Flying Instructor',
    'Foreign aid worker',
    'Foreman',
    'Forestry - Chipper Chopper Faller Logger Lumberjack',
    'Gardener',
    'Gasfitter',
    'General Contractor',
    'General Practitioner',
    'Glazier',
    'Graphic Designer',
    'Gynecologist',
    'Hair Stylist',
    'Handyman',
    'Healthcare Worker',
    'Heavy Equipment Operator',
    'Homemaker',
    'Horse Breaker',
    'Horticulture',
    'Housekeeper',
    'Housewife',
    'Hypnotist',
    'Immigration Officer',
    'Instructor (Non pilot or diving)',
    'Insurance Agent',
    'IT Consultant',
    'IT Technician',
    'Janitor',
    'Journalist',
    'Judge',
    'Labourer',
    'Laid-Off',
    'Law Enforcement (bomb squad)',
    'Law Enforcement (non-bomb squad)',
    'Law Enforcement (SWAT or other tactical team)',
    'Lawyer',
    'Lead Miner',
    'Lecturer',
    'Legal Adviser',
    'Legal Assistant',
    'Legal Secretary',
    'Lifeguard',
    'Mail carrier',
    'Mailman',
    'Manager',
    'Manager of Operations',
    'Marijuana related',
    'Marketing',
    'Mechanic',
    'Mechanical Engineer',
    'Messenger',
    'Metal worker',
    'Military',
    'Miner - Underground',
    'Miner (Explosives)',
    'Mining - Management Supervisory',
    'Mining Engineer (No Manual Work)',
    'Mining Foreman',
    'Missionary',
    'Money Broker',
    'Mule Breaker',
    'Musician',
    'Nanny',
    'Nuclear Engineer',
    'Nuclear Physicist',
    'Nuclear Scientist',
    'Nuclear Technicia',
    'Nurse',
    'OB/GYN',
    'Obstetrician',
    'Occupational Therapist',
    'Office Administrator',
    'Office Work',
    'Offshore Fisherman',
    'Oil Industry',
    'Optician',
    'Optician (including technician and assistant)',
    'Optometrist',
    'Oral Surgeon',
    'Orthodontist',
    'Orthopedic Surgeon',
    'Osteopath',
    'Other Occupation',
    'Paramedic',
    'Pathologist',
    'Performer',
    'Personal Assistant',
    'Pharmacist',
    'Phlebotomist',
    'Photographer',
    'Physician (Not Armed Forces)',
    'Physician Assistant',
    'Physicist',
    'Physiotherapist',
    'Pilot (Commercial)',
    'Pilot (Private)',
    'Plant Operator',
    'Plumber',
    'Police (bomb squad/disposal)',
    'Police (non-bomb squad/ or disposal)',
    'Police (SWAT or other tactical team)',
    'Police Sergeant',
    'Political figure',
    'Politician',
    'Post Office Worker',
    'Prison Officer',
    'Prison Warden',
    'Private Investigator',
    'Probation Officer',
    'Professional Athlete',
    'Professional Gambler',
    'Professor',
    'Programmer',
    'Property Manager',
    'Prosthetist (orthotist)',
    'Psychiatrist',
    'Psychologist',
    'Psychotherapist',
    'Radiographer',
    'Radiologist',
    'Ranching',
    'Real Estate',
    'Real Estate Broker',
    'Realtor',
    'Receptionist',
    'Recruiter',
    'Regulatory',
    'Rehabilitation therapist',
    'Reporter',
    'Retail',
    'Retail Proprietor',
    'Retail Shop Manager',
    'Retired',
    'Road Worker (general)',
    'Roofer',
    'Sales Manager',
    'Sales Representative',
    'Scientist',
    'Secretary',
    'Security Guard (armed)',
    'Security Guard (unarmed)',
    'Self employed',
    'Senior Consultant',
    'Server',
    'Silversmith',
    'Singer',
    'Smelter',
    'Smoke jumper',
    'Social Worker',
    'Software Consultant',
    'Software Engineer',
    'Solicitor',
    'Speech pathologist',
    'Speech therapist',
    'Stay-at-Home Dad',
    'Stay-at-Home Mom',
    'Stay-at-Home Parent',
    'Stockbroker',
    'Storeman',
    'Street Cleaner',
    'Structural Engineer',
    'Student',
    'supervisor',
    'Surgeon',
    'Surgeon (Not Armed Forces)',
    'Tailor',
    'Tax Consultant',
    'Teacher',
    'Technical Engineer',
    'Technician',
    'Telecommunications Engineer',
    'Tour Guide',
    'Transportation',
    'Tree Feller',
    'Truck Driver',
    'Undertaker',
    'Underwriter',
    'Unemployed',
    'Usher',
    'Vehicle Technician',
    'Veterinarian',
    'Vice President',
    'Waiter',
    'Waitress',
    'Warehouse Manager',
    'Warehouse worker',
];
export const EMC_COUNTRY_LIST = [
    'United States of America',
    'Canada',
    'Russian Federation',
    'Egypt',
    'South Africa',
    'Greece',
    'Netherlands',
    'Belgium',
    'France',
    'Spain',
    'Hungary',
    'Yugoslavia',
    'Italy',
    'Romania',
    'Switzerland',
    'DEPRECATED - Czechloslovakia',
    'Austria',
    'United Kingdom',
    'Denmark',
    'Sweden',
    'Norway',
    'Poland',
    'Germany',
    'Peru',
    'Mexico',
    'Cuba',
    'Argentina',
    'Brazil',
    'Chile',
    'Colombia',
    'Venezuela',
    'Malaysia',
    'Australia',
    'Indonesia',
    'Philippines',
    'New Zealand',
    'Singapore',
    'Thailand',
    'Japan',
    'DEPRECATED - Korea',
    'Viet Nam',
    'China',
    'Turkey',
    'India',
    'Pakistan',
    'Afghanistan',
    'Sri Lanka',
    'DEPRECATED - Burma (Union Of Myanmar)',
    'Iran, Islamic Republic of',
    'Morocco',
    'Algeria',
    'Tunisia',
    'Libya',
    'Gambia',
    'Senegal',
    'Mauritania',
    'Mali',
    'Guinea',
    'DEPRECATED - Ivory Coast, Republic Of',
    'Burkina Faso',
    'Niger',
    'Togo',
    'Benin',
    'Mauritius',
    'Liberia',
    'Sierra Leone',
    'Ghana',
    'Nigeria',
    'Chad',
    'Central African Republic',
    'Cameroon',
    'Cape Verde',
    'Sao Tome and Principe',
    'Equatorial Guinea',
    'Gabon',
    'Bahamas',
    'DEPRECATED - Zaire',
    'Angola',
    'Barbados',
    'DEPRECATED - Ascension Islands',
    'Aland Islands',
    'Sudan',
    'Rwanda',
    'Ethiopia',
    'Somalia',
    'Djibouti',
    'Kenya',
    'Tanzania, United Republic of',
    'Uganda',
    'Burundi',
    'Mozambique',
    'Zambia',
    'Madagascar',
    'Reunion',
    'Zimbabwe',
    'Namibia',
    'Malawi',
    'Lesotho',
    'Botswana',
    'Antigua and Barbuda',
    'Comoros',
    'Guinea-Bissau',
    'Congo, the Democratic Republic of the',
    'Virgin Islands, British',
    'Saint Helena, Ascension and Tristan da Cunha',
    'Aruba',
    'Faroe Islands',
    'Greenland',
    'Cayman Islands',
    'Gibraltar',
    'Portugal',
    'Luxembourg',
    'Ireland',
    'Iceland',
    'Albania',
    'Malta',
    'Cyprus',
    'Finland',
    'Bulgaria',
    'Guernsey',
    'Lithuania',
    'Latvia',
    'Estonia',
    'Moldova, Republic of',
    'Armenia',
    'Belarus',
    'Andorra',
    'San Marino',
    'Ukraine',
    'Croatia',
    'Slovenia',
    'Bosnia and Herzegovina',
    'Macedonia, The Former Yugoslav Republic of',
    'Kosovo',
    'Czech Republic',
    'Slovakia',
    'Liechtenstein',
    'Bermuda',
    'Grenada',
    'Falkland Islands (Malvinas)',
    'Belize',
    'Guatemala',
    'El Salvador',
    'Honduras',
    'Nicaragua',
    'Costa Rica',
    'Saint Pierre and Miquelon',
    'Haiti',
    'Puerto Rico',
    'Virgin Islands, US',
    'South Georgia and the South Sandwich Islands',
    'Sint Maarten (Dutch Part)',
    'Bonaire, Sint Eustatius and Saba',
    'Guadeloupe',
    'Bolivia',
    'Guyana',
    'Ecuador',
    'French Guiana',
    'Paraguay',
    'Martinique',
    'Suriname',
    'Uruguay',
    'Netherlands Antilles',
    'Turks and Caicos Islands',
    'Saint Barthelemy',
    'Saint Martin (French Part)',
    'Montserrat',
    'DEPRECATED - Saipan',
    'Guam',
    'Antarctica',
    'Brunei Darussalam',
    'Nauru',
    'Papua New Guinea',
    'Tonga',
    'Solomon Islands',
    'Vanuatu',
    'Fiji',
    'Wallis and Futuna',
    'Cook Islands',
    'Niue',
    'American Samoa',
    'DEPRECATED - Western Samoa',
    'Kiribati',
    'New Caledonia',
    'Tuvalu',
    'French Polynesia',
    'Northern Mariana Islands',
    'Palau',
    'Marshall Islands',
    'Micronesia, Federated States of',
    'South Sudan',
    'Saint Lucia',
    'Dominica',
    'Saint Vincent and the Grenadines',
    'Dominican Republic',
    'Hong Kong',
    'Macao',
    'Cambodia',
    "Lao People's Democratic Republic",
    'Trinidad and Tobago',
    'Saint Kitts and Nevis',
    'Jamaica',
    'Bangladesh',
    'Taiwan, Province of China',
    'Myanmar',
    'Korea, Republic of',
    "Korea, Democratic People's Republic of",
    'Lebanon',
    'Jordan',
    'Syrian Arab Republic',
    'Iraq',
    'Kuwait',
    'Saudi Arabia',
    'Yemen',
    'Oman',
    'United Arab Emirates',
    'Israel',
    'Bahrain',
    'Qatar',
    'Bhutan',
    'Nepal',
    'Tajikistan',
    'Turkmenistan',
    'Azerbaijan',
    'Georgia',
    'Uzbekistan',
    'Anguilla',
    'Panama (also known as Canal Zone)',
    "Cote d'Ivoire",
    'Eritrea',
    'Kazakhstan',
    'Kyrgyzstan',
    'Cocos (Keeling) Islands',
    'Mongolia',
    'Bouvet Island',
    'Seychelles',
    'British Indian Ocean Territory',
    'DEPRECATED - Cocoa Islands',
    'Samoa',
    'Timor-Leste',
    'French Southern Territories',
    'Heard Island and McDonald Islands',
    'Mayotte',
    'Pitcairn',
    'Svalbard and Jan Mayen',
    'Tokelau',
    'United States Minor Outlying Islands',
    'Western Sahara',
    'Maldives',
    'Christmas Island',
    'Norfolk Island',
    'Curacao',
    'Congo',
    'Monaco',
    'Holy See (Vatican City State)',
    'DEPRECATED - Diego Garcia',
    'Swaziland',
    'Palestine, State of',
    'Jersey',
    'Isle of Man',
    'Serbia',
    'Montenegro',
    'North Yemen',
    'South Yemen',
    'Union of Soviet Socialist Republics',
    'Other',
];
